'use strict';

var keyMirror = require('react/lib/keyMirror');

module.exports = keyMirror({
  TERMS: null,
  SETTINGS: null,
  RESET_PASSWORD: null,
  LOGIN: null,
  SIGNUP: null,
  FINISH_SIGNUP: null,
  REQUEST_RESET_PASSWORD: null,
  SEND_INVITE: null,
  ABOUT: null,
  FEEDBACK: null,
  EDITOR_HELP: null,
  STAMPLET: null,
  CONTACT_US: null
});


/** WEBPACK FOOTER **
 ** ./constants/ModalTypes.js
 **/